import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__collections } from '../STATE__collections';

export const LOCAL__collection_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.COLLECTION_DELETE,
  payload,
});

export function INIT_LOCAL__collection_delete(state: STATE__collections, action: PayloadAction<string[]>) {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.collections_map.delete(id);
    state.custom_collections_map.delete(id);

    /*
     * SELECTED COLLECTIONS
     */

    if (state.collection_current._id == id) {
      state.collection_current = DTO__collection.CREATE_STUB();
    }

    /*
     * SPECIAL COLLECTIONS
     */

    if (state.collection_viewed_on_search._id == id) {
      state.collection_viewed_on_search = DTO__collection.CREATE_STUB();
    }

    if (state.collection_favorites._id == id) {
      state.collection_favorites = DTO__collection.CREATE_STUB();
    }

    if (state.collection_uploads._id == id) {
      state.collection_uploads = DTO__collection.CREATE_STUB();
    }

    if (state.collection_generated._id == id) {
      state.collection_generated = DTO__collection.CREATE_STUB();
    }
  }

  //need to force re-render
  state.collections_map = new Map(state.collections_map);
  state.custom_collections_map = new Map(state.custom_collections_map);
}
